import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { getGrabList as _getGrabList, getGrabOptions as _getGrabOptions } from '@/api/material/grab';
import Pagination from '@/components/Pagination/index.vue';
import GrabList from './list.vue';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';

var searchField = [{
  value: 'app_name',
  label: '按APP名称'
}, {
  value: 'package_name',
  label: '按包名'
}, {
  value: 'id',
  label: '按ID'
}];

export default {
  components: {
    Pagination: Pagination,
    GrabList: GrabList,
    SearchBar: SearchBar
  },

  mixins: [searchMixin],

  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        platform: '',
        network: '',
        category: '',
        is_playable: '',
        search_field: '',
        keyword: '',
        time: []
      },

      formItemList: [{
        type: 'business',
        subtype: 'platform-selector',
        prop: 'platform'
      }, {
        type: 'select',
        prop: 'network',
        params: {
          disabled: false,
          readonly: false,
          clearable: true,
          placeholder: '请输入渠道',
          options: []
        }
      }, {
        type: 'select',
        prop: 'category',
        params: {
          disabled: false,
          readonly: false,
          clearable: true,
          placeholder: '请输入类别',
          options: []
        }
      }, {
        type: 'select',
        prop: 'is_playable',
        params: {
          disabled: false,
          readonly: false,
          clearable: true,
          placeholder: '请输入类型',
          options: [{
            value: 1,
            label: 'Playable'
          }, {
            value: 2,
            label: '非 Playable'
          }, {
            value: 3,
            label: 'Unknown'
          }]
        }
      }, {
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        params: {
          disabled: false,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        }
      }, {
        type: 'select',
        prop: 'search_field',
        params: {
          disabled: false,
          readonly: false,
          clearable: true,
          placeholder: '请选择搜索字段',
          options: searchField
        }
      }, {
        type: 'input',
        prop: 'keyword',
        subtype: 'text',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            clearable: true,
            placeholder: formValue.search_field ? searchField.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      }],

      listLoading: false,
      grabList: [],

      pagination: {
        total: 0
      }
    };
  },


  watch: {
    $route: function $route(to, from) {
      this.getGrabList(this.query);
    }
  },

  mounted: function mounted() {
    this.getGrabOptions();
    this.getGrabList(this.query);
  },


  methods: {
    getGrabList: function getGrabList(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;

                _context.prev = 1;
                _context.next = 4;
                return _getGrabList(params);

              case 4:
                res = _context.sent;

                _this.grabList = _.get(res, 'data.data.list');
                _this.pagination.total = _.get(res, 'data.data.total');
                _this.listLoading = false;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10]]);
      }))();
    },
    getGrabOptions: function getGrabOptions() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, networks, categories;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _getGrabOptions();

              case 3:
                res = _context2.sent;
                networks = _.get(res, 'data.data.networks');
                categories = _.get(res, 'data.data.categories');


                _this2.formItemList = _this2.formItemList.map(function (item) {
                  if (item.prop === 'network') {
                    return _Object$assign({}, item, {
                      params: _extends({}, item.params, {
                        options: networks.map(function (network) {
                          return {
                            value: network,
                            label: network
                          };
                        })
                      })
                    });
                  }
                  if (item.prop === 'category') {
                    return _Object$assign({}, item, {
                      params: _extends({}, item.params, {
                        options: categories.map(function (category) {
                          return {
                            value: category,
                            label: category
                          };
                        })
                      })
                    });
                  }
                  return item;
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.$message.error(_context2.t0.message);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
};